import { BookingFormData, BookingResponse } from '../types/bookingTypes'
import { MRT_ColumnFiltersState, MRT_PaginationState, MRT_SortingState } from 'mantine-react-table'

const API_BASE_URL = process.env.REACT_APP_NEST_URL || 'http://localhost:2022'

export interface ApiResponse<T> {
  data?: T
  error?: string
  message?: string
}

export default interface PageParam {
  pagination: MRT_PaginationState
  columnFilters?: MRT_ColumnFiltersState
  sorting: MRT_SortingState
  globalFilter?: string
}

export const bookingApi = {
  create: async (data: BookingFormData): Promise<BookingResponse> => {
    const response = await fetch(`${API_BASE_URL}/booking`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}))
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`)
    }

    return response.json()
  },

  update: async (id: string, status: string, adminComments: string[]): Promise<BookingResponse> => {
    const response = await fetch(`${API_BASE_URL}/booking/${id}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ status, adminComments }),
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    return response.json()
  },

  getAll: async (): Promise<BookingResponse[]> => {
    const response = await fetch(`${API_BASE_URL}/booking`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    return response.json()
  },

  getById: async (id: string | null): Promise<BookingResponse> => {
    const response = await fetch(`${API_BASE_URL}/booking/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    return response.json()
  },

  getAvailableTimeSlots: async (date: string): Promise<BookingResponse[]> => {
    const response = await fetch(`${API_BASE_URL}/booking/view-bookings/${date}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    return response.json()
  },

  delete: async (id: string): Promise<void> => {
    const response = await fetch(`${API_BASE_URL}/booking/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
  },
}
